// Ensure intl-tel-input search box has proper padding
const ensureIntlTelInputStyle = () => {
  if (document.getElementById('iti-search-style')) return
  const style = document.createElement('style')
  style.id = 'iti-search-style'
  style.innerHTML = `.iti__search-input { padding-left: 2.5rem !important; }`
  document.head.appendChild(style)
}

// Initialize international phone number inputs with a country selector.
//
// Shared by the user forms (User.js) and the order-checkout e-invoice form
// (user_dashboard.js), so it must be idempotent: an input that intl-tel-input
// has already wrapped (in an `.iti` container) is skipped to avoid double-init.
//
// On submit, the field is rewritten with the full E.164 number (e.g. +60123456789,
// +447911123456), which the backend's PhoneNumber::E164 normalizer accepts as-is —
// so buyers can enter a local number for any country, not just Malaysia.
export const initPhoneInputs = () => {
  const phoneInputs = Array.from(document.querySelectorAll('input[id$="_phone"]'))
  if (phoneInputs.length === 0 || typeof window.intlTelInput !== 'function') return

  ensureIntlTelInputStyle()

  const options = {
    initialCountry: 'my',
    separateDialCode: true,
    autoPlaceholder: 'polite',
    preferredCountries: ['my', 'sg'],
    excludeCountries: ['kp'],
    nationalMode: false,
    loadUtils: () =>
      import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.10.10/build/js/utils.js'),
  }

  phoneInputs.forEach((telInput) => {
    // Skip inputs already initialized (intl-tel-input wraps them in an `.iti` container).
    if (telInput.closest('.iti')) return

    const iti = window.intlTelInput(telInput, options)
    const form = telInput.form || document

    const updatePhoneValue = () => {
      const updatedFullPhone = iti.getNumber()
      telInput.value = updatedFullPhone
    }

    form.addEventListener('submit', updatePhoneValue)
  })
}

export default initPhoneInputs
